export const environment = {
    cctvURL: 'https://testcctv.scaits.net',
    // apiUrl: 'http://192.168.1.47:8180',
    // apiUrl:'http://103.206.115.62:8180',
    // apiUrl:'http://192.168.1.47:8280/',
    // devStreamURL: 'https://devcctvstream.scaits.net',
    // ticketUrl: 'http://192.168.20.88:8081',
    // ticketUrl: 'http://192.168.20.88:8081',
    ticketUrl: 'https://testreportsapi.scaits.net',
    devStreamURL: 'https://cctvstreamtest.scaits.net',
    apiCalls: "https://testupipayments.scaits.net",
    //    counsellingUrl:'https://testwebservice.scaits.net',
    apiUrl: localStorage.getItem("backendBaseURL"),
    counsellingUrl: localStorage.getItem("backendBaseURL"),
    wifiUrl: localStorage.getItem("backendBaseURL"),
    //    marikUrl:'https://testmeraki.scaits.net',
    // wifiUrl:'http://192.168.5.68:8081',
    merakiUrl: localStorage.getItem("backendBaseURL1"),
    parentReport: 'https://testparent.scaits.net/',
    //  counsellingurl
    CourseFeeUrl: localStorage.getItem("backendBaseURL"),
    // Attendancebackendurl
    AttendanceUrl: localStorage.getItem("backendBaseURL"),
    Commonurl: localStorage.getItem("backendBaseURL1"),
    cctvorgfusion: localStorage.getItem("WebService"),
    // CourseFeeUrl:'http://192.168.5.59:8086/apiV2',
    orgUrl: 'http://192.168.5.69:8086',
    // CourseFeeUrl: 'https://testmasters.scaits.net/apiV2',
    employeeURL: 'https://testwebservice.scaits.net',
    printasseturl: 'https://testmasters.scaits.net',
    masterDomain: 'https://testmasters.scaits.net',
    // masterDomain:"http://localhost:8086",
    attendanceDomain: 'https://testattendance.scaits.net',
    logTrack: 'https://testlogs.scaits.net/',
    s3url: 'http://192.168.1.24',
    s3imageUrl: 'https://stg-scaits-srichaitanya-social.s3.ap-south-1.amazonaws.com/',
    scoreOtpGenerateUrl: 'https://comservice.infinitylearn.com',
    scoreOtpVerifyUrl: 'https://gatewayapilearn.infinitylearn.com',
    scoreOtpTenantId: '1',
    scoreOtpProductId: '300',
    scoreOtpTenant: 'infinitylearn',
    scoreEosApiUrl: 'https://eosapi.infinitylearn.com',
    scoreRecaptchaSiteKey: '6LcLWcwrAAAAAMHP8O6cYf3uVpEjt3mtp4oBPZKb',
    ag_grid_key: "Using_this_{AG_Grid}_Enterprise_key_{AG-078264}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Varsity_Education_Management_Pvt._Ltd.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{SCAITS}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{SCAITS}_need_to_be_licensed___{SCAITS}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{28_February_2026}____[v3]_[01]_MTc3MjIzNjgwMDAwMA==cdfeb1b372c192ec32fa3bf91001f0b7",
    jeemains: 'http://192.168.20.79:8086',

    websocket: {
        enabled: true,
        url: 'https://testmisreports.scaits.net/ws',
        path: '/ws',
        reconnectDelayMs: 5000,
        maxReconnectAttempts: 10,
        heartbeatIntervalMs: 30000,
    },
};
